import React, { createRef, ReactNode, useEffect, useState } from "react";
import Slider from "react-slick";
import YouTubeTakeover from "components/YouTubeTakeover";
import cx from "classnames";
import st from "./index.module.scss";
import SliderText from "./SliderText";
import { useRouter } from "next/router";
import FlavorSlide from "components/FlavorSlide";

export default function HomePageHeroSlider(): JSX.Element {
  const textSliderRef = createRef<Slider>();
  const buttonSliderRef = createRef<Slider>();
  const mainSliderRef = createRef<Slider>();

  const [currentIndex, setCurrentIndex] = useState<number>(-1);
  const [openVideoModal, setOpenVideoModal] = useState<boolean>(false);
  const [navState, setNavState] = useState<{
    textNav: Slider | undefined;
    buttonNav: Slider | undefined;
    mainNav: Slider | undefined;
  }>({
    textNav: undefined,
    buttonNav: undefined,
    mainNav: undefined,
  });

  const router = useRouter();

  useEffect(() => {
    mainSliderRef.current?.slickPause();
    setNavState({
      textNav: textSliderRef.current || undefined,
      buttonNav: buttonSliderRef.current || undefined,
      mainNav: mainSliderRef.current || undefined,
    });
    setTimeout(
      (slider) => {
        setCurrentIndex(0);
        slider?.slickPlay();
      },
      500,
      mainSliderRef.current
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appendDots = (dots: ReactNode[]) => <div>{dots}</div>;

  const customPaging = (i: number) => {
    const textClass = cx(st.text, i === currentIndex ? st.activeText : "");

    const renderPaging = () => {
      switch (i) {
        case 0:
          return (
            <p className={textClass}>
              {"A refreshing boost of Hydration + Energy (160mg of Caffeine)"}
            </p>
          );
        case 1:
          return (
            <p className={textClass}>
              {"Zero Sugar. Zero Excuses. Fully-Charged to Keep You Going."}
            </p>
          );
      }
    };

    return (
      <div className={st.paging}>
        {i === currentIndex ? (
          <div className={st.active} />
        ) : (
          <div className={st.inActive} />
        )}
        <div className={cx(st.textWrapper, st.text)}>{renderPaging()}</div>
      </div>
    );
  };

  const mainSliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    fade: true,
    autoplaySpeed: 4000,
    arrows: false,
    centerMode: true,
    centerPadding: "0",
    swipeToSlide: false,
    appendDots: appendDots,
    customPaging: customPaging,
    beforeChange: (_: number, next: number) => setCurrentIndex(next),
  };

  const textSliderSettings = {
    infinite: true,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
  };

  const buttonSliderSettings = {
    dots: false,
    fade: true,
    arrows: false,
  };

  return (
    <div className={st.container}>
      <div className={st.textButtonSlider}>
        <Slider
          ref={textSliderRef}
          asNavFor={navState.mainNav}
          {...textSliderSettings}
          className={st.textSlider}
        >
          <SliderText
            smallHeader={<>Bestsellers</>}
            largeHeader={
              <>
                Recovery
                <br />
                Orangeade &
                <br />
                Lemonade
              </>
            }
          />
          <SliderText
            smallHeader={
              <>
                Pure Zero
                <br />
                <i>Zero Sugar. Zero Excuses.</i>
              </>
            }
            largeHeader={<>Fruit Punch & Silver Ice</>}
          />
        </Slider>
        <Slider
          ref={buttonSliderRef}
          asNavFor={navState.textNav}
          {...buttonSliderSettings}
        >
          <button
            onClick={() => router.push("/products/orange")}
            className={st.button}
          >
            Stock Up Now
          </button>
          <button
            onClick={() => router.push("/products/pure-zero-fruit-punch")}
            className={st.button}
          >
            Shop Now
          </button>
        </Slider>
      </div>
      <Slider
        ref={mainSliderRef}
        asNavFor={navState.buttonNav}
        className={st["slick-slider-custom"]}
        {...mainSliderSettings}
      >
        <FlavorSlide
          bgImg="https://www.datocms-assets.com/74813/1687909278-desktop_2337x1350-2.png"
          mobileBgImg="https://www.datocms-assets.com/74813/1687909271-mobile_600x800-2.png"
          canImg="https://www.datocms-assets.com/74813/1687909284-desktop_can_1026x1350.png"
        />
        <FlavorSlide
          bgImg="https://www.datocms-assets.com/74813/1689789558-desktop_2337x1350_v2.png"
          mobileBgImg="https://www.datocms-assets.com/74813/1689789564-mobile_600x800_v2.png"
          canImg="https://www.datocms-assets.com/74813/1689789552-can_desktop_1026x1350.png"
        />
      </Slider>
    </div>
  );
}
